import { DragDropContext, DragDropContextProvider } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import React from 'react';
// github.com/react-dnd/react-dnd/issues/186
import { microAppUtil } from '@platform/api';

//import HTML5Backend from '../HTML5Backend/index.js';
// 保证单例
let __DndDropContext = null;
if (window) {
    __DndDropContext = window.__DndDropContext || DragDropContext(HTML5Backend);
    window.__DndDropContext = __DndDropContext;
} else {
    __DndDropContext = DragDropContext(HTML5Backend);
}
export default __DndDropContext;

//使用DragDropContextProvider方式，可以传window（事件生效的dom）
// export default function(C, element) {
//     if(!element){
//         element = microAppUtil.getDocument();
//     }
//     element.document = document;
//     element.clearTimeout = window.clearTimeout;
//     element.cancelAnimationFrame = window.cancelAnimationFrame;
//     element.requestAnimationFrame = window.requestAnimationFrame;

//     return function(props) {
//         return <DragDropContextProvider backend={HTML5Backend} window={element}>
//             <C {...props}></C>
//         </DragDropContextProvider>;
//     };
// }

// export default function(C, element) {
//     if(!element){
//         element = microAppUtil.getDocument();
//     }
//     // element.document = document;
//     // element.clearTimeout = window.clearTimeout;
//     // element.cancelAnimationFrame = window.cancelAnimationFrame;
//     // element.requestAnimationFrame = window.requestAnimationFrame;

//     return function(props) {
//         return <DragDropContextProvider backend={HTML5Backend} window={element}>
//             <C {...props}></C>
//         </DragDropContextProvider>;
//     };
// }